import {
  ADMIN_ACCESS,
  get24HoursAgoTimeStamp,
  getCurrentUserRole,
  getFutureTimestamp,
  pincodeManagementAccess,
  ROLES_NAME,
  todaysEndDate,
  todaysStartDate,
  QA_QUESTIONS_ACCESS,
  DOCTOR_BOOKING_FLAG,
  MTD_REPORT_ACCESS,
  SALES_DASHBOARD_ACCESS,
  CONVIN_DASHBOARD_ACCESS,
  AUTO_QA_DASHBOARD_ACCESS,
  CALL_DASHBOARD_ACCESS,
  COMMUNITY_ACCESS_EMAILS,
  KPI_DASHBOARD_ACCESS,
} from "modules/utilities/utility";
import {
  getFormattedStartDate,
  getFormattedEndDate,
  revenueRepStartDate,
  revenueRepEndDate,
} from "functionCall";
import moment from "moment";
import secureLocalStorage from "react-secure-storage";

const start = moment().subtract(0, "days").startOf("day");
const end = moment().endOf(getFormattedStartDate);
const currentUserMail = secureLocalStorage.getItem("email");

export const dashboard = {
  label: "Dashboard",
  labelDisable: true,
  children: [
    {
      name: "Dashboard",
      exact: true,
      active: true,
      icon: "chart-pie",
      to:
        getCurrentUserRole() == "support" || getCurrentUserRole() == "team_lead"
          ? "/my-tickets?tab=assigned"
          : "/dashboard?tab=home",
    },
  ],
};
export const caseManagement = {
  label: "Case Management",
  labelDisable: true,
  children: [
    {
      name: "Case Management",
      active: true,
      icon: "video",
      children: [
        // {
        //   name: "Sales Management",
        //   to: "case-management/sales-management",
        //   exact: true,
        //   active: true,
        // },
        {
          name: "New Leads",
          to: "/case-management/new-leads",
          active: true,
        },
        {
          name: "All Leads",
          to: "/case-management/all-leads",
          active: true,
        },
        {
          name: "All Cases",
          to: "/case-management/all-cases",
          active: true,
        },
        {
          name: "Vayu Lead",
          to: "/case-management/vayu-lead",
          active: true,
        },
        {
          name: "All Cases Tags",
          to: "/case-management/all-cases-tag?tagName=Oral Minoxidil&pageNumber=1",
          active: true,
        },
        {
          name: "Slot Booking",
          to: "/case-management/slot-booking?pageNumber=1",
          active: true,
        },
      ],
    },
  ],
};

export const customer_data_menu = {
  label: "Customer Data",
  labelDisable: true,
  children: [
    {
      name: "Customer Data",
      active: true,
      icon: "database",
      children: [
        {
          name: "Customer Data",
          to: "/customer-data?tab=table",
          active: true,
        },
        {
          name: "Retention Cohort Analysis",
          to: "/customer-data?tab=cohort",
          active: true,
        },
        {
          name: "Reorder Cohort Analysis",
          to: "/customer-data?tab=reorder-cohort",
          active: true,
        },
      ],
    },
  ],
};

export const admin_configure = {
  label: "Configure",
  labelDisable: true,
  children: [
    {
      name: "Configure",
      active: true,
      icon: "tools",
      children: [
        {
          name: "Medicines",
          to: "/configure/medicines",
          exact: true,
          active: true,
        },
        {
          name: "Tags",
          to: "/configure/tags",
          active: true,
        },
        {
          name: "Product Mapping",
          to: "/configure/product-mapping",
          active: true,
        },
        {
          name: "Settings",
          to: "/configure/settings",
          active: true,
        },
        {
          name: "Discount Code",
          to: "/discount-codes",
          active: true,
        },
        {
          name: "Bulk Kit Cohort Config",
          to: "/configure/offline-bulk-kit-cohort-config",
          active: true,
        },
        {
          name: "Ticket Configure",
          to: "/configure-ticket",
          active: true,
        },
        {
          name: "RBAC Management",
          to: "/rbac-configure",
          active: true,
        },
        {
          name: "Ticket Group Management",
          to: "/ticket-group-management",
          active: true,
        },
        {
          name: "Clinic Management",
          to: "/clinic-management",
          active: true,
        },
        {
          name: "Offline Doctor Roaster",
          to: "/offline-doctor-roaster",
          active: true,
        },
        {
          name: "Webinars",
          to: "/webinar-management",
          active: true,
        },
      ],
    },
  ],
};

export const whatsappAnalytics = {
  label: "WhatsApp Analytics",
  labelDisable: true,
  children: [
    {
      name: "WhatsApp Analytics",
      exact: true,
      active: true,
      icon: "comment",
      to: "/whatsapp-analytics",
    },
  ],
};

export const voiceBotAnalytics = {
  label: "Voice Bot Analytics",
  labelDisable: true,
  children: [
    {
      name: "Voice Bot Analytics",
      exact: true,
      active: true,
      icon: "chart-line",
      to: "/voice-bot-analytics",
    },
  ],
};

export const adminOrderManagement = {
  label: "Order Management",
  labelDisable: true,
  children: [
    {
      name: "Order Management",
      active: true,
      icon: "envelope-open",
      children: [
        {
          name: "Transfer Order",
          to: "/order-management",
          exact: true,
          active: true,
        },
        {
          name: "All Orders",
          to: "/order-management/all-orders?pageNumber=1",
          active: true,
        },
        {
          name: "Update Orders",
          to: "/order-management/update_order",
          active: true,
        },
        {
          name: "Open Orders",
          to: "/order-management/open_orders?pageNumber=1",
          active: true,
        },
        // {
        //   name: "Recent Orders",
        //   to: "/order-management/recent_orders?pageNumber=1",
        //   active: true,
        // },
        {
          name: "Ghost Orders",
          to: "/order-management/ghost-orders?pageNumber=1",
          active: true,
        },
        {
          name: "Assigned Doctors",
          to: "/order-management/assigned-doctors?pageNumber=1",
          active: true,
        },
        {
          name: "Return Orders",
          to: "/order-management/return-orders",
          active: true,
        },
        {
          name: "COD to Prepaid",
          to: "/order-management/cod-to-prepaid?pageNumber=1",
          active: true,
        },
        {
          name: "OTS Mapper",
          to: "/order-tracking-service",
          active: true,
        },
        {
          name: "NDR Mapper",
          to: "/ndr-mapper",
          active: true,
        },
        {
          name: "NDR Mapper Master",
          to: "/ndr-mapper-master",
          active: true,
        },
        {
          name: "Offline Orders",
          to: "/order-management/offline-orders",
          active: true,
        },
        {
          name: "Refund Management",
          to: "/order-management/refund-management",
          active: true,
        },
        {
          name: "Track Order",
          to: "/admin-order-management/track-order",
          active: true,
        },
      ],
    },
  ],
};

export const sales_report = {
  label: "Sales Report",
  labelDisable: true,
  children: [
    {
      name: "Sales Report",
      active: true,
      icon: "chart-line",
      children: [
        {
          name: "Sales Charts",
          exact: true,
          active: true,
          to: "/financial-dashboard",
        },
        {
          name: "New Sales Charts",
          exact: true,
          active: true,
          to: "/new-sales-dashboard",
        },
        {
          name: "Order Dashboard",
          exact: true,
          active: true,
          to: "/order-dashboard",
        },
        {
          name: "Inventory Tracker",
          exact: true,
          active: true,
          to: "/inventory-tracker",
        },
        {
          name: "Report Charts",
          exact: true,
          active: true,
          to: "/report-dashboard",
        },
        ...(MTD_REPORT_ACCESS
          ? [
              {
                name: "Month Report",
                exact: true,
                active: true,
                to: "/mtd-report",
              },
            ]
          : []),
        {
          name: "Sales Data",
          exact: true,
          active: true,
          to: "/admin-dashboard?tab=salesDashboard",
        },
        {
          name: "Utm Campaign",
          exact: true,
          active: true,
          to: "/utm-campaign",
        },
        {
          name: "Revenue Tracking",
          exact: true,
          active: true,
          to: `/revenue-tracking`,
        },
        {
          name: "Transaction and Payment Gateway",
          exact: true,
          active: true,
          to: "/transactions-dashboard",
        },
        {
          name: "Checkout Cart",
          exact: true,
          active: true,
          to: "/checkout-success-rate",
        },
        {
          name: "Web Funnel Dashboard",
          exact: true,
          active: true,
          to: "/funnel-dashboard",
        },
      ],
    },
  ],
};

export const operation_management = {
  label: "Operation Management",
  labelDisable: true,
  children: [
    {
      name: "Operation Management",
      active: true,
      icon: "globe",
      children: [
        {
          name: "Warehouse",
          exact: true,
          active: true,
          to: "/warehouse?tab=stock",
        },
        {
          name: "Invoice & Credit Note",
          exact: "true",
          active: true,
          to: `/invoice?tab=invoice`,
        },
        {
          name: "Misc Orders",
          exact: "true",
          active: true,
          to: `/misc-orders`,
        },
        {
          name: "Reports",
          exact: true,
          active: true,
          to: "/reports?tab=active-customer-report",
        },
        {
          name: "Zoho",
          exact: "true",
          active: true,
          to: `/zoho`,
        },
        {
          name: "UniCommerce Dashboard",
          exact: true,
          active: true,
          to: "/uni_commerce_dashboard",
        },
        {
          name: "Warehouse Pincode",
          exact: true,
          active: true,
          to: "/warehouse-pincode-mapping",
        },
        {
          name: "Bulk Upload Delhivery",
          exact: true,
          active: true,
          to: "/bulk-upload/delhivery",
        },
        {
          name: "Refund Tracking",
          exact: true,
          active: true,
          to: "/refund-tracking",
        },
        {
          name: "NA NDR Orders",
          exact: true,
          active: true,
          to: "/na-ndr-orders",
        },
        {
          name: "Unshipped Orders",
          exact: true,
          active: true,
          to: "/unshipped-orders",
        },
        {
          name: "Control Tower",
          exact: true,
          active: true,
          to: "/control-tower",
        },
      ],
    },
  ],
};

export const adminDashboard = {
  label: "admin dashboard",
  labelDisable: true,
  children: [
    {
      name: "Admin Dashboard",
      exact: true,
      active: true,
      icon: "home",
      to: "/admin-dashboard?tab=salesDashboard",
    },
    {
      name: "NPS Dashboard",
      active: true,
      icon: "chart-bar",
      children: [
        {
          name: "NPS Dashboard",
          exact: true,
          active: true,
          to: "/nps-dashboard/nps-analysis",
        },
        {
          name: "NPS V2",
          exact: true,
          active: true,
          to: "/nps-dashboard/nps-v2",
        },
      ],
    }
  ],
};

export const ticketsRoutes = {
  label: "My Tickets",
  labelDisable: true,
  children: [
    {
      name: "my Tickets",
      exact: true,
      active: true,
      icon: "ticket-alt",
      to: "/my-tickets?tab=assigned",
    },
  ],
};

export const ticketMaster = {
  label: "Ticket Master",
  labelDisable: true,
  children: [
    {
      name: "Ticket Master",
      exact: true,
      active: true,
      icon: "chart-bar",
      to: "/ticket-master",
    },
  ],
};

export const doctoreActionable = {
  label: "Actionable",
  labelDisable: true,
  children: [
    {
      name: "Actionable",
      exact: true,
      active: true,
      icon: "search",
      to: "/actionable-doctor",
    },
  ],
};

export const myPrescriptions = {
  label: "My Prescriptions",
  labelDisable: true,
  children: [
    {
      name: "My Prescriptions",
      exact: true,
      active: true,
      icon: "capsules",
      to: "/my-prescriptions",
    },
  ],
};

export const IVRCall = {
  label: "IVR Calls",
  labelDisable: true,
  children: [
    {
      name: "IVR Calls",
      exact: true,
      active: true,
      icon: "user",
      to: "/ivrCall",
    },
  ],
};
export const search = {
  label: "Search",
  labelDisable: true,
  children: [
    {
      name: "Search",
      exact: "true",
      active: true,
      icon: "search",
      to: `/search`,
    },
  ],
};

export const nextCall = {
  label: "Next calls",
  labelDisable: true,
  children: [
    {
      name: "Next Calls",
      exact: true,
      active: true,
      icon: "phone",
      to: "/next-call",
    },
  ],
};

export const nextCallV2 = {
  label: "Next calls V2",
  labelDisable: true,
  children: [
    {
      name: "Next Calls V2",
      exact: true,
      active: true,
      icon: "phone",
      to: "/next-call-v2",
    },
  ],
};

export const manageWeeklyFeedback = {
  label: "Manage Weekly Feedback",
  labelDisable: true,
  children: [
    {
      name: "Manage Weekly Schedule",
      exact: true,
      active: true,
      icon: "calendar-alt",
      to: `manage-weekly-schedules?sd=${revenueRepStartDate(
        getFormattedEndDate(1)
      )}&ed=${revenueRepEndDate(getFormattedEndDate(0))}`,
    },
  ],
};

export const customerFeedBack = {
  label: "Customer Feedback",
  labelDisable: true,
  children: [
    {
      name: "Customer Feedback",
      exact: true,
      active: true,
      icon: "comments",
      to: `/customerFeedback?pageNumber=1&sd=${encodeURIComponent(
        revenueRepStartDate(getFormattedStartDate())
      )}&ed=${encodeURIComponent(revenueRepEndDate(getFormattedStartDate))}`,
    },
  ],
};

export const customerActiveChats = {
  label: "Customer Chats",
  labelDisable: true,
  children: [
    {
      name: "Customer Active Chats",
      exact: true,
      active: true,
      icon: "comment",
      to: "/customer-chats?pageNumber=1",
    },
  ],
};

export const engagementReport = {
  label: "Engagements Reports",
  labelDisable: true,
  children: [
    {
      name: "Engagements Report",
      exact: "true",
      active: true,
      icon: "table",
      to: `/engagement-report?tab=slot_booking&startDate=${encodeURIComponent(
        moment().startOf("day").subtract(1, "days")
      )}&endDate=${encodeURIComponent(moment().endOf("day"))}`,
    },
  ],
};

export const allocation = {
  label: "Allocation",
  labelDisable: true,
  children: [
    {
      name: "Allocation",
      active: true,
      icon: "tasks",
      children: [
        {
          name: "Allocation Jobs",
          to: "/allocation",
          exact: true,
          active: true,
        },
        {
          name: "Bulk Allocation",
          to: "/bulk-deactivate",
          exact: true,
          active: true,
        },
      ],
    },
  ],
};

export const myTeam = {
  label: "My Team",
  labelDisable: true,
  children: [
    {
      name: "My Team",
      exact: "true",
      active: true,
      icon: "users",
      to: "/myteam",
    },
  ],
};

export const orderManagement = {
  label: "My Team",
  labelDisable: true,
  children: [
    {
      name: "Order Management",
      exact: "true",
      active: true,
      icon: "users",
      to: "/order-management",
    },
  ],
};

export const allOrderManagement = {
  label: "All Order",
  labelDisable: true,
  children: [
    {
      name: "All Order",
      exact: "true",
      active: true,
      icon: "users",
      to: "/order-management/all-orders?pageNumber=1",
    },
  ],
};

export const myAppointments = {
  label: "My Team",
  labelDisable: true,
  children: [
    {
      name: "My Appointments",
      exact: "true",
      active: true,
      icon: "user",
      to: `/my-appointments?startDate=${moment()
        .startOf("day")
        .toISOString()}&endDate=${moment().endOf("day").toISOString()}`,
    },
  ],
};

export const slotBookingLoggers = {
  label: "Slot Booking Loggers",
  labelDisable: true,
  children: [
    {
      name: "Slot Booking Loggers",
      exact: "true",
      active: true,
      icon: "user",
      to: `/slot-booking-loggers?pageNumber=1&sd=${revenueRepStartDate(
        getFormattedEndDate(1)
      )} &ed=${revenueRepEndDate(getFormattedStartDate())}`,
    },
  ],
};

export const callStats = {
  label: "Call Stats",
  labelDisable: true,
  children: [
    {
      name: "Call Stats",
      exact: "true",
      active: true,
      icon: "phone",
      to: `/call-stats?sd=${todaysStartDate()}&ed=${todaysEndDate()}`,
    },
  ],
};

export const callDashboard = {
  label: "Call Dashboard",
  labelDisable: true,
  children: [
    {
      name: "Call Dashboard",
      exact: "true",
      active: true,
      icon: "chart-bar",
      to: "/call-dashboard",
    },
  ],
};

export const engagementDashboards = {
  label: "Engagement Dashboards",
  labelDisable: true,
  children: [
    {
      name: "Engagement Dashboards",
      active: true,
      icon: "chart-pie",
      children: [
        {
          name: "Outbound Summary",
          to: "/engagement-dashboards/outbound-summary",
          active: true,
        },
        {
          name: "Engagement Analytics",
          to: "/engagement-dashboards/engagement-details",
          active: true,
        },
        {
          name: "Slot Pendency",
          to: "/engagement-dashboards/slot-pendency",
          active: true,
        },
        {
          name: "Overall Pendency Dashboard",
          to: "/engagement-dashboards/daily-pendency",
          active: true,
        },
        {
          name: "Agent Login Report",
          to: "/engagement-dashboards/agent-login-report",
          active: true,
        },
        {
          name: "Agent Performance",
          to: "/engagement-dashboards/agent-performance",
          active: true,
        },
        {
          name: "Agent Performance (Due Date)",
          to: "/engagement-dashboards/agent-performance-due",
          active: true,
        },
        {
          name: "Same Coach Analytics",
          to: "/engagement-dashboards/same-coach",
          active: true,
        },
        {
          name: "Slot Availability Dashboard",
          to: "/engagement-dashboards/slot-availability",
          active: true,
        },
      ],
    },
  ],
};

export const umamiAnalytics = {
  label: "Umami Analytics",
  labelDisable: true,
  children: [
    {
      name: "Umami Analytics",
      active: true,
      icon: "chart-line",
      to: "/funnel-analytics",
    },
  ],
};


export const prescribedPatients = {
  label: "Prescribed Patients",
  labelDisable: true,
  children: [
    {
      name: "Prescribed Patients",
      exact: "true",
      active: true,
      icon: "users",
      to: `/prescribed-patients?startDate=${moment()
        .subtract(1, "month")
        .endOf("month")
        .format("YYYY-MM-DD")}&endDate=${moment()
        .endOf("month")
        .format("YYYY-MM-DD")}&pageNo=1`,
    },
  ],
};

export const doctorDashboard = {
  label: "Dashboard",
  labelDisable: true,
  children: [
    {
      name: "Dashboard",
      exact: "true",
      active: true,
      icon: "chart-pie",
      to:
        getCurrentUserRole() == "consult_doctor"
          ? `/home?startDate=${encodeURIComponent(
              revenueRepStartDate(getFormattedEndDate(1))
            )}&endDate=${encodeURIComponent(
              revenueRepEndDate(getFormattedStartDate())
            )}`
          : getCurrentUserRole() === "doctor"
          ? "/home?pageNo=1"
          : "/home",
    },
  ],
};

export const doctorBooking = {
  label: "Doctor",
  labelDisable: true,
  children: [
    {
      name: "Doctor",
      active: true,
      icon: "user-plus",
      children: [
        {
          name: "Doctor Booking",
          to: `/doctor-booking?sd=${get24HoursAgoTimeStamp()}&ed=${getFutureTimestamp()}`,
          exact: true,
          active: true,
        },
        {
          name: "Offline Doctor Roaster",
          to: "/offline-doctor-roaster",
          exact: true,
          active: true,
        },
      ],
    },
  ],
};

export const supportFeedback = {
  label: "Feedback",
  labelDisable: true,
  children: [
    {
      name: "Feedback",
      exact: "true",
      active: true,
      icon: "comments",
      to: `/feedback?tab=Build-a-Plan&pag=1`,
    },
  ],
};

export const invoiceGenerate = {
  label: "Invoice and Credit Notes",
  labelDisable: true,
  children: [
    {
      name: "Invoice & Credit Note",
      exact: "true",
      active: true,
      icon: "file-alt",
      to: `/invoice?tab=invoice`,
    },
  ],
};

export const community = {
  label: "Community",
  labelDisable: true,
  children: [
    {
      name: "Community",
      exact: "true",
      active: true,
      icon: "users",
      to: `/community`,
    },
  ],
};

export const storeVisit = {
  label: "Store visit",
  labelDisable: true,
  children: [
    {
      name: "Store Visit",
      exact: "true",
      active: true,
      icon: "users",
      to: `/store-visit`,
    },
  ],
};

export const miscOrders = {
  label: "miscOrders",
  labelDisable: true,
  children: [
    {
      name: "Misc Orders",
      exact: "true",
      active: true,
      icon: "users",
      to: `/misc-orders`,
    },
  ],
};

export const revenueTracking = {
  label: "revenueTracking",
  labelDisable: true,
  children: [
    {
      name: "Revenue Tracking",
      exact: true,
      active: true,
      icon: "users",
      to: `/revenue-tracking`,
    },
  ],
};

export const reports = {
  label: "Reports",
  labelDisable: true,
  children: [
    {
      name: "Reports",
      exact: true,
      active: true,
      icon: "envelope-open",
      to: "/reports?tab=active-customer-report",
    },
  ],
};

export const zoho = {
  label: "Zoho",
  labelDisable: true,
  children: [
    {
      name: "Zoho",
      exact: "true",
      active: true,
      icon: "tags",
      to: `/zoho`,
    },
  ],
};

export const warehouse = {
  label: "Warehouse",
  labelDisable: true,
  children: [
    {
      name: "Warehouse",
      exact: true,
      active: true,
      icon: "home",
      to: "/warehouse?tab=stock",
    },
  ],
};

export const admin_case_management = {
  label: "Warehouse",
  labelDisable: true,
  children: [
    {
      name: "Transfer Customer",
      exact: true,
      active: true,
      icon: "exchange-alt",
      to: "/admin-case-management?tab=transfer_customer",
    },
  ],
};

export const userManagement = {
  label: "User Management",
  labelDisable: true,
  children: [
    {
      name: "User Management",
      to: "/user-management",
      exact: true,
      active: true,
      icon: "tasks",
    },
  ],
};

export const deviceMonitoring = {
  label: "Device Monitoring",
  labelDisable: true,
  children: [
    {
      name: "Device Monitoring",
      to: "/device-monitoring",
      exact: true,
      active: true,
      icon: "desktop",
    },
  ],
};

export const pgReconciliation = {
  label: "PG Reconciliation",
  labelDisable: true,
  children: [
    {
      name: "PG Reconciliation",
      to: "/pg-reconciliation",
      exact: true,
      active: true,
      icon: "chart-line",
    },
  ],
};

export const adminCms = {
  label: "CMS",
  labelDisable: true,
  children: [
    {
      name: "CMS",
      active: true,
      icon: "paper-plane",
      children: [
        {
          name: "Manage Segments",
          to: "/manage-segments",
          exact: true,
          active: true,
        },
        {
          name: "Manage Compon...",
          to: "/manage-components",
          active: true,
        },
        {
          name: "Manage Contents",
          to: "/manage-contents",
          active: true,
        },
        {
          name: "Manage Tags",
          to: "/manage-tags",
          active: true,
        },
        {
          name: "Master Table",
          to: "/manage-master-table",
          active: true,
        },
      ],
    },
  ],
};

export const financialDashboard = {
  label: "financialDashboard",
  labelDisable: true,
  children: [
    {
      name: "Sales Data",
      exact: true,
      active: true,
      icon: "chart-line",
      to: "/financial-dashboard",
    },
  ],
};

export const GroupManagement = {
  label: "Group Management",
  labelDisable: true,
  children: [
    {
      name: "Group Management",
      exact: true,
      active: true,
      icon: "tags",
      to: "/group-management",
    },
  ],
};

export const paymentStatus = {
  label: "Transaction and Payment Gateway",
  labelDisable: true,
  children: [
    {
      name: "Transaction and Payment Gateway",
      exact: true,
      active: true,
      icon: "tags",
      to: "/transactions-dashboard",
    },
  ],
};
export const utmCampaign = {
  label: "Utm Campaign",
  labelDisable: true,
  children: [
    {
      name: "Utm Campaign",
      exact: true,
      active: true,
      icon: "globe",
      to: "/utm-campaign",
    },
  ],
};

export const performanceDashboard = {
  label: "Performance Dashboard",
  labelDisable: true,
  children: [
    {
      name: "Performance Dashboard",
      exact: true,
      active: true,
      icon: "table",
      to: "/performance_dashboard",
    },
  ],
};

export const medicalEscalationTickets = {
  label: "Medical Escalation Tickets",
  labelDisable: true,
  children: [
    {
      name: "Medical Escalation Tickets",
      exact: true,
      active: true,
      icon: "tag",
      to: "/medical-esaclation-tickets",
    },
  ],
};

export const ticketGroupManangement = {
  label: "Medical Escalation Tickets",
  labelDisable: true,
  children: [
    {
      exact: true,
      icon: "wrench",
      name: "Ticket Group Management",
      to: "/ticket-group-management",
      active: true,
    },
  ],
};

export const updatePincode = {
  label: "Pincode Management ",
  labelDisable: true,
  children: [
    {
      exact: true,
      icon: "home",
      name: "Pincode Management",
      to: "/pincode-management",
      active: true,
    },
  ],
};

export const productivity_dashboard = {
  label: "Pincode Management ",
  labelDisable: true,
  children: [
    {
      exact: true,
      icon: "bolt",
      name: "Productivity Dashboard",
      to: "/productivity-dashboard",
      active: true,
    },
  ],
};

export const SSOTDashboard = {
  label: "SSOT Dashboard",
  labelDisable: true,
  children: [
    {
      exact: true,
      icon: "home",
      name: "SSOT Dashboard",
      to: "/ssot",
      active: true,
    },
  ],
};

// Attendeance & Leave tracker
export const userAttendanceLeave = {
  label: "User Attendance",
  labelDisable: true,
  children: [
    {
      name: "Attendance Tracker",
      active: true,
      icon: "paper-plane",
      children: [
        {
          name: "Leave Tracker",
          to: "/leave-tracker",
          exact: true,
          active: true,
        },
      ],
    },
  ],
};

// Attendeance & Leave tracker
export const userAttendance = {
  label: "User Attendance",
  labelDisable: true,
  children: [
    {
      name: "Attendance Tracker",
      active: true,
      icon: "paper-plane",
      children: [
        {
          name: "Attendance Tracker",
          to: "/attendance-tracker",
          exact: true,
          active: true,
        },
        {
          name: "Leave Tracker",
          to: "/leave-tracker",
          exact: true,
          active: true,
        },
      ],
    },
  ],
};
// Attendeance & Leave tracker
export const userAttendanceApproval = {
  label: "User Attendance",
  labelDisable: true,
  children: [
    {
      name: "Attendance Tracker",
      active: true,
      icon: "paper-plane",
      children: [
        {
          name: "Attendance Tracker",
          to: "/attendance-tracker",
          exact: true,
          active: true,
        },
        {
          name: "Leave Tracker",
          to: "/leave-tracker",
          exact: true,
          active: true,
        },
        {
          name: "Approvals Tracker",
          to: "/approvals-tracker",
          exact: true,
          active: true,
        },
      ],
    },
  ],
};

export const ClinicsDashBoard = {
  label: "Doctor Appointment",
  labelDisable: true,
  children: [
    {
      exact: true,
      icon: "home",
      name: "Doctor Appointment",
      to: "/clinic-dashboard",
      active: true,
    },
  ],
};

export const leadDashboard = {
  label: "Dashboard",
  labelDisable: true,
  children: [
    {
      name: "Dashboard",
      exact: true,
      active: true,
      icon: "chart-pie",
      to: "/lead-dashboard",
    },
  ],
};

export const covinDashboard = {
  label: "Dashboard",
  labelDisable: true,
  children: [
    {
      name: "Convin Dashboard",
      exact: true,
      active: true,
      icon: "flag",
      to: "/covin-dashboard",
    },
  ],
};

export const qaDashboardAdmins = {
  label: "Quality Analysis",
  labelDisable: true,
  children: [
    {
      name: "Quality Analysis",
      active: true,
      icon: "bolt",
      children: [
        {
          name: "Audited Engagements",
          to: "/main-content",
          active: true,
        },
        {
          name: "My Work",
          to: "/my-work",
          active: true,
        },
      ],
    },
  ],
};

export const llmQaAudit = {
  label: "Auto QA Audit",
  labelDisable: true,
  children: [
    {
      name: "Auto QA Audit",
      active: true,
      icon: "robot",
      children: [
        {
          name: "Evaluations",
          to: "/qa-audit",
          active: true,
        },
        {
          name: "Convin Dispatch",
          to: "/convin-dispatch",
          active: true,
        },
      ],
    },
  ],
};

export const qaDashboardManagers = {
  label: "Quality Analysis",
  labelDisable: true,
  children: [
    {
      name: "Quality Analysis",
      active: true,
      icon: "bolt",
      children: [
        {
          name: "Audited Engagements",
          to: "/main-content",
          active: true,
        },
      ],
    },
  ],
};

export const qaDashboardAgents = {
  label: "Quality Analysis",
  labelDisable: true,
  children: [
    {
      name: "Quality Analysis",
      active: true,
      icon: "bolt",
      children: [
        {
          name: "My Work",
          to: "/my-work",
          exact: true,
          active: true,
        },
      ],
    },
  ],
};

//Incentives Dashboard
export const incentivesCalculatorAdmins = {
  label: "Incentives Calculator Dashboard",
  labelDisable: true,
  children: [
    {
      name: "Incentives Calculator Dashboard",
      active: true,
      icon: "flag",
      children: [
        {
          name: "Incentives Slab ",
          to: "/incentives-slab",
          exact: true,
          active: true,
        },
        {
          name: "Achieved Score ",
          to: "/incentives-achievedScore",
          exact: true,
          active: true,
        },
        {
          name: "Weightage and Target",
          to: "/weightage-target",
          exact: true,
          active: true,
        },
      ],
    },
  ],
};

export const kpiDashboardAdmins = {
  label: "KPI Dashboard",
  labelDisable: true,
  children: [
    {
      name: "KPI Dashboard",
      active: true,
      icon: "chart-pie",
      children: [
        {
          name: "KPI Calling",
          to: "/kpi-calling",
          exact: true,
          active: true,
        },
        {
          name: "KPI Historical Dashboard",
          to: "/kpi-historical-dashboard",
          exact: true,
          active: true,
        },
        {
          name: "Medical KPI ",
          to: "/medical-kpi",
          exact: true,
          active: true,
        },
        {
          name: "Complaint KPI ",
          to: "/complaint-kpi",
          exact: true,
          active: true,
        },
        {
          name: "Call Attempts Dashboard",
          to: "/manager-call-attempts",
          exact: true,
          active: true,
        },
        {
          name: "Call Transfer Audit Dashboard",
          to: "/call-transfer-audit",
          exact: true,
          active: true,
        },
      ],
    },
  ],
};
export const productivityDashboard = {
  label: "Productivity Dashboard",
  labelDisable: true,
  children: [
    {
      name: "Productivity Dashboard",
      exact: "true",
      active: true,
      icon: "phone",
      to: `/idealtimecalculator`,
    },
  ],
};

export const doctorsTab = {
  label: "Store Orders",
  labelDisable: true,
  children: [
    {
      exact: true,
      icon: "home",
      name: "Store Orders",
      to: "/clinic-home?page=1",
      active: true,
    },
  ],
};

export const incentivesDashboard = {
  label: " Incentives Dashboard",
  labelDisable: true,
  children: [
    {
      name: " Incentives Dashboard",
      active: true,
      icon: "stream",
      children: [
        {
          name: "Calling Incentives ",
          to: "/incentives-calculator",
          exact: true,
          active: true,
        },
        {
          name: "Medical Incentives ",
          to: "/medical-incentives",
          exact: true,
          active: true,
        },
        {
          name: "Complaints Incentives ",
          to: "/complaints-incentives",
          exact: true,
          active: true,
        },
      ],
    },
  ],
};

export const prescriptionApproval = {
  label: "UPrescription Approval",
  labelDisable: true,
  children: [
    {
      name: "Prescription Approval",
      exact: true,
      active: true,
      icon: "envelope-open",
      to: "/approve-prescriptions",
    },
  ],
};

export const receptionistDashboard = {
  label: "Clinic Appointment",
  labelDisable: true,
  children: [
    {
      name: "Clinic Appointment",
      exact: true,
      active: true,
      icon: "chart-pie",
      to: "/receptioninst-dashboard",
    },
  ],
};

export const cmsDashboard = {
  label: "Dashboard",
  labelDisable: true,
  children: [
    {
      name: "Dashboard",
      exact: true,
      active: true,
      icon: "chart-pie",
      to: "/dashboard?tab=home",
    },
  ],
};
export const utmDashboard = {
  label: "Utm Campaign",
  labelDisable: true,
  children: [
    {
      name: "Utm Campaign",
      exact: true,
      active: true,
      icon: "chart-pie",
      to: "/utm-campaign",
    },
  ],
};

export const storeCustomerAssignments = {
  label: "Store Customer Assignments",
  labelDisable: true,
  children: [
    {
      exact: true,
      icon: "home",
      name: "Store Customer Assignments",
      to: "/store-customer-assignment",
      active: true,
    },
  ],
};

export const salesDashboard = {
  label: "Sales Dashboard",
  labelDisable: true,
  children: [
    {
      name: "Report Charts",
      icon: "chart-line",
      exact: true,
      active: true,
      to: "/financial-dashboard",
    },
  ],
};

const roleConfig = {
  medical_rep_level_3: [
    dashboard,
    ticketsRoutes,
    IVRCall,
    nextCall,
    nextCallV2,
    myTeam,
    manageWeeklyFeedback,
    customerFeedBack,
    customerActiveChats,
    engagementReport,
    medicalEscalationTickets,
    userAttendance,
  ],
  medical_rep: [
    dashboard,
    ticketsRoutes,
    IVRCall,
    nextCall,
    nextCallV2,
    customerFeedBack,
    customerActiveChats,
    engagementReport,
    medicalEscalationTickets,
    userAttendance,
    ...(KPI_DASHBOARD_ACCESS ? [kpiDashboardAdmins] : []),
  ],
  medrep_ext: [dashboard, ticketsRoutes, nextCall, nextCallV2, userAttendance,incentivesDashboard,],
  doctor: [doctorDashboard, doctoreActionable, ticketsRoutes, myAppointments, doctorBooking, prescribedPatients,incentivesDashboard, myPrescriptions, ...(DOCTOR_BOOKING_FLAG ? [ticketsRoutes] : [])],
  support: [
    ticketsRoutes,
    customerFeedBack,
    orderManagement,
    allOrderManagement,
    invoiceGenerate,
    doctorBooking,
    supportFeedback,
    caseManagement,
    userAttendanceLeave,
    ...(AUTO_QA_DASHBOARD_ACCESS ? [llmQaAudit] : []),
    ...(KPI_DASHBOARD_ACCESS ? [kpiDashboardAdmins] : []),
  ],
  lead_agent: [
    leadDashboard,
    utmDashboard,
    ticketsRoutes,
    customerFeedBack,
    nextCall,
    nextCallV2,
    orderManagement,
    allOrderManagement,
    invoiceGenerate,
    doctorBooking,
    supportFeedback,
    caseManagement,
    userAttendance,
    ...(KPI_DASHBOARD_ACCESS ? [kpiDashboardAdmins] : []),
  ],
  chat_call_agent: [
    leadDashboard,
    utmDashboard,
    ticketsRoutes,
    customerFeedBack,
    nextCall,
    nextCallV2,
    orderManagement,
    allOrderManagement,
    invoiceGenerate,
    doctorBooking,
    supportFeedback,
    caseManagement,
    userAttendance,
    ...(KPI_DASHBOARD_ACCESS ? [kpiDashboardAdmins] : []),
  ],
  consult_doctor: [doctorDashboard, ticketsRoutes, doctorBooking],
  ivr: [dashboard, ticketsRoutes, userAttendance],
  community: [ticketsRoutes, community, userAttendance],
  community_level_2: [
    ticketsRoutes,
    customerFeedBack,
    orderManagement,
    allOrderManagement,
    invoiceGenerate,
    doctorBooking,
    supportFeedback,
    caseManagement,
    community,
    userAttendance,
  ],
  chat: [
    ticketsRoutes,
    customerFeedBack,
    orderManagement,
    invoiceGenerate,
    userAttendance,
    ...(KPI_DASHBOARD_ACCESS ? [kpiDashboardAdmins] : []),
  ],
  orm: [ticketsRoutes, orderManagement, invoiceGenerate],
  medical: [
    dashboard,
    ticketsRoutes,
    allOrderManagement,
    doctorBooking,
    medicalEscalationTickets,
    userAttendance,
  ],
  quality: [
    supportFeedback,
    ticketsRoutes,
    doctorBooking,
    customerFeedBack,
    engagementReport,
    caseManagement,
    userAttendance,
    ...(KPI_DASHBOARD_ACCESS ? [kpiDashboardAdmins] : []),
    llmQaAudit,
    voiceBotAnalytics,
  ],
  dispatch: [
    dashboard,
    ticketsRoutes,
    caseManagement,
    admin_case_management,
    adminOrderManagement,
    search,
    miscOrders,
    invoiceGenerate,
    zoho,
    userAttendance,
  ],

  admin: [
    adminDashboard,
    ...(SALES_DASHBOARD_ACCESS ? [salesDashboard] : []),
    ticketsRoutes,
    admin_case_management,
    caseManagement,
    adminOrderManagement,
    operation_management,
    performanceDashboard,
    doctorBooking,
    admin_configure,
    manageWeeklyFeedback,
    engagementReport,
    allocation,
    supportFeedback,
    slotBookingLoggers,
    community,
    storeVisit,
    invoiceGenerate,
    revenueTracking,
    medicalEscalationTickets,
    ticketGroupManangement,
    kpiDashboardAdmins,
    productivityDashboard,
    ...(CONVIN_DASHBOARD_ACCESS ? [covinDashboard] : []),
    ...(CALL_DASHBOARD_ACCESS ? [callDashboard] : []),
    ...(AUTO_QA_DASHBOARD_ACCESS ? [llmQaAudit] : []),
    engagementDashboards,
    umamiAnalytics,
  ],
  team_lead: [
    ticketsRoutes,
    // customerFeedBack,
    orderManagement,
    engagementReport,
    // allOrderManagement,
    // invoiceGenerate,
    // doctorBooking,
    // supportFeedback,
    // caseManagement,
    // slotBookingTotal,
    kpiDashboardAdmins,
    SSOTDashboard,
    userAttendanceApproval,
    productivityDashboard,
    manageWeeklyFeedback,
    ...(AUTO_QA_DASHBOARD_ACCESS ? [llmQaAudit] : []),
  ],
  operations_admin: [
    ticketsRoutes,
    adminOrderManagement,
    warehouse,
    miscOrders,
    invoiceGenerate,
    revenueTracking,
    zoho,
    userAttendance,
  ],
  operations: [
    dashboard,
    ticketsRoutes,
    IVRCall,
    nextCall,
    nextCallV2,
    customerFeedBack,
    customerActiveChats,
    engagementReport,
    userAttendance,
  ],
  super_admin: [
    sales_report,
    ticketsRoutes,
    productivity_dashboard,
    covinDashboard,
    admin_case_management,
    caseManagement,
    adminOrderManagement,
    operation_management,
    performanceDashboard,
    doctorBooking,
    customer_data_menu,
    admin_configure,
    whatsappAnalytics,
    voiceBotAnalytics,
    manageWeeklyFeedback,
    engagementReport,
    allocation,
    supportFeedback,
    slotBookingLoggers,
    storeCustomerAssignments,
    adminCms,
    community,
    storeVisit,
    medicalEscalationTickets,
    kpiDashboardAdmins,
    productivityDashboard,
    llmQaAudit,
    callDashboard,
    engagementDashboards,
    umamiAnalytics,
    ticketMaster,
  ],
  medrep_ext_ss: [ticketsRoutes],
  medrep_ext_cnx: [ticketsRoutes],
  doctor_admin: [
    ticketsRoutes,
    caseManagement,
    adminOrderManagement,
    doctorBooking,
    manageWeeklyFeedback,
    engagementReport,
    supportFeedback,
    slotBookingLoggers,
    community,
    invoiceGenerate,
    userAttendance,
  ],
  sales: [dashboard, ticketsRoutes, nextCall, nextCallV2],
  read_only: [dashboard],
  clinic_receptionist: [
    ClinicsDashBoard,
    receptionistDashboard,
    ticketsRoutes,
    ...(KPI_DASHBOARD_ACCESS ? [kpiDashboardAdmins] : []),
    ...(COMMUNITY_ACCESS_EMAILS.includes(currentUserMail) ? [community] : [])],
  clinic_doctor: [myAppointments, doctorsTab, prescribedPatients],
  maker: [cmsDashboard],
  checker: [cmsDashboard],
  publisher: [cmsDashboard],
};
const currentUserTeam = secureLocalStorage.getItem("team");

const currentUserRole = getCurrentUserRole();
const currentUserLevel = secureLocalStorage.getItem("level");
const level = [1, 2, 3, 4, 5];
let exportedData;
if (currentUserRole === "medical_rep" && currentUserLevel == "3") {
  exportedData = roleConfig.medical_rep_level_3;
} else if (currentUserRole === "medical_rep") {
  exportedData = roleConfig.medical_rep;
} else if (currentUserRole === "community" && currentUserLevel == "2") {
  exportedData = roleConfig.community_level_2;
} else if (roleConfig[currentUserRole]) {
  exportedData = roleConfig[currentUserRole];
} else if (roleConfig[currentUserRole]) {
  exportedData = roleConfig[currentUserRole];
} else {
  exportedData = roleConfig.medical_rep;
}
if (
  roleConfig[currentUserRole] &&
  level.includes(currentUserLevel) &&
  ADMIN_ACCESS.includes(currentUserRole)
) {
  roleConfig[currentUserRole].push(
    userManagement,
    deviceMonitoring,
    SSOTDashboard,
    userAttendanceApproval
  );
}

// PG Reconciliation is visible to all authenticated users
if (exportedData) {
  exportedData.push(pgReconciliation);
}

if (currentUserRole === ROLES_NAME.DOCTOR && currentUserLevel === 1) {
  roleConfig.doctor.push(prescriptionApproval);
}

// Add next call for doctor level 3
if (currentUserRole === ROLES_NAME.DOCTOR && currentUserLevel == 3) {
  roleConfig.doctor.push(nextCall);
  roleConfig.doctor.push(nextCallV2);
}

// Add prescription approval to doctor submenu for admin roles
if (ADMIN_ACCESS.includes(currentUserRole)) {
  const doctorMenuIndex = exportedData.findIndex(
    (menu) => menu.label === "Doctor"
  );
  if (doctorMenuIndex !== -1) {
    const doctorChildren = exportedData[doctorMenuIndex].children[0].children;
    doctorChildren.push({
      name: "Prescription Approval",
      to: "/approve-prescriptions",
      exact: true,
      active: true,
    });
  }
}

if (pincodeManagementAccess.includes(currentUserMail)) {
  exportedData = [...exportedData, updatePincode];
}

export default exportedData;
